<template>
  <section class="ang-head">
    <div class="ang-head__eyebrow">
      <span class="ang-head__dot"></span>
      <span class="brand-mark">WaizmannVergleich</span>&nbsp;/&nbsp;INFOPAKET ANFORDERN
    </div>

    <h1 class="ang-head__title">
      Jetzt Antrag &amp; Infopaket anfordern
      <span class="ang-head__free">— kostenlos</span>
    </h1>
    <p class="ang-head__sub">
      Sie fordern unverbindlich Unterlagen an. Es entstehen keine Kosten.
    </p>

    <div class="ang-head__tarif">
      <div class="ang-head__tarif-main">
        <div class="ang-head__tarif-name">
          <strong>{{ tarif.un_name }}</strong>
          <span class="ang-head__tarif-title">{{ tarif.tarif_title }}</span>
        </div>
        <div class="ang-head__tarif-meta">
          Empfehlung für
          <span class="ang-head__chip">{{ berechnung.show_ber_geschlecht }}</span>
          <span class="ang-head__chip">{{ berechnung.show_ber_geburtstag }}</span>
          <router-link to="/vergleich/starten" class="ang-head__edit">
            <v-icon icon="mdi-pencil-outline" size="13" class="mr-1" />
            ändern
          </router-link>
        </div>
      </div>
      <div class="ang-head__tarif-price">
        <span class="ang-head__price-num">{{ tarif.preis_value }}&nbsp;€</span>
        <span class="ang-head__price-unit">mtl.</span>
      </div>
    </div>

    <div v-if="!sharedDataStore.isMobile()" class="ang-head__includes">
      <div class="ang-head__includes-label">
        <v-icon icon="mdi-package-variant-closed" size="16" class="mr-1" />
        Ihr Infopaket enthält
      </div>
      <a class="ang-head__includes-item" @click="showInfopaket = true">
        <span class="ang-head__num">1</span> umfangreiche Tarifinfos
      </a>
      <a class="ang-head__includes-item" @click="showInfopaket = true">
        <span class="ang-head__num">2</span> Versicherungsdaten
      </a>
      <a
        v-if="berechnung.ber_segment <= 1"
        class="ang-head__includes-item"
        @click="showInfopaket = true"
      >
        <span class="ang-head__num">3</span> Clearment Zugangsdaten
      </a>
    </div>

    <v-dialog v-model="showInfopaket" width="888">
      <v-card class="pa-4">
        <InfoPaket :tarif="tarif" :berechnung="berechnung" />
      </v-card>
    </v-dialog>
  </section>
</template>

<script setup>
  import { ref, defineProps } from "vue";
  import InfoPaket from "@/components/berechnung/info/InfoPaket";
  import { useSharedDataStore } from "@/stores/sharedData";
  const sharedDataStore = useSharedDataStore();
  defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });
  const showInfopaket = ref(false);
</script>

<style scoped>
  .ang-head {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 14px 18px;
  }
  .ang-head__eyebrow {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: #5b6473;
    text-transform: uppercase;
    margin-bottom: 6px;
  }
  .ang-head__dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0f4c81;
    margin-right: 8px;
  }
  .ang-head__title {
    font-size: clamp(20px, 2.4vw, 26px);
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px;
    line-height: 1.2;
    letter-spacing: -0.3px;
  }
  .ang-head__free {
    color: #0f4c81;
    font-weight: 700;
  }
  .ang-head__sub {
    font-size: 13.5px;
    color: #4b5563;
    margin: 0 0 12px;
  }

  .ang-head__tarif {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: center;
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 10px 12px;
  }
  .ang-head__tarif-main {
    min-width: 0;
  }
  .ang-head__tarif-name {
    font-size: 15px;
    color: #0f172a;
    line-height: 1.25;
  }
  .ang-head__tarif-name strong {
    font-weight: 700;
  }
  .ang-head__tarif-title {
    color: #4b5563;
    margin-left: 4px;
    font-weight: 500;
  }
  .ang-head__tarif-meta {
    margin-top: 4px;
    font-size: 12.5px;
    color: #6b7280;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
  .ang-head__chip {
    display: inline-flex;
    align-items: center;
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    padding: 1px 6px;
    font-size: 11.5px;
    color: #1f2937;
    font-weight: 600;
  }
  .ang-head__edit {
    color: #0f4c81;
    text-decoration: none;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  .ang-head__edit:hover {
    text-decoration: underline;
  }
  .ang-head__tarif-price {
    text-align: right;
    white-space: nowrap;
  }
  .ang-head__price-num {
    font-size: 22px;
    font-weight: 800;
    color: #0f4c81;
    letter-spacing: -0.4px;
    font-variant-numeric: tabular-nums;
  }
  .ang-head__price-unit {
    font-size: 12px;
    color: #6b7280;
    margin-left: 2px;
  }

  .ang-head__includes {
    margin-top: 10px;
    display: grid;
    grid-template-columns: auto 1fr 1fr 1fr;
    gap: 8px 14px;
    padding: 8px 0 0;
    border-top: 1px solid #eef1f6;
    align-items: center;
  }
  .ang-head__includes-label {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    color: #5b6473;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
  .ang-head__includes-item {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    color: #1f2937;
    cursor: pointer;
    text-decoration: none;
  }
  .ang-head__includes-item:hover {
    color: #0f4c81;
  }
  .ang-head__num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: #0f4c81;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    border-radius: 3px;
    margin-right: 6px;
  }

  @media (max-width: 720px) {
    .ang-head__tarif {
      grid-template-columns: 1fr;
    }
    .ang-head__tarif-price {
      text-align: left;
    }
    .ang-head__includes {
      grid-template-columns: 1fr;
    }
  }
</style>
